import { observer } from "mobx-react-lite";
import { FC } from "react";

import { routes } from "@libs/routing/routes.ts";
import { useStores } from "@stores/hooks/useStores.ts";
import { usePatientLabel } from "@ui-components/hooks/usePatientLabel.ts";
import { Navigate } from "@ui-components/navigation/Navigate.tsx";

import { RecentPatientsDetailsProps } from "./RecentPatientsList.types.ts";

export const RecentPatientLink: FC<RecentPatientsDetailsProps> = observer(
  ({ recentPatient }) => {
    const { core } = useStores();
    if (recentPatient.userId !== core.userId) return null;
    return (
      <Navigate
        to={routes.contacts.contact.path({ id: recentPatient.patientId })}
      >
        Go to {usePatientLabel()}
      </Navigate>
    );
  }
);
